import * as yup from 'yup';

export class Code {
    Id: string;
    EmersonId?: number;
    AttributeId: string;
    Name: string;
    Description: string;
    ShortDescription: string;        
    SortOrder: number;
}

export const CodeValidationSchema = yup.object().shape({
    ShortDescription: yup.string().min(1, 'Required')
});